const MEMBER_SEARCH_TABLE_COL = [
  {
    displayName: "Member Name & Address",
    key: ["membersName", "membersAddress"],
  },
  {
    displayName: "Phone & Email",
    key: ["phone", "email"],
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Area",
    key: "area",
  },
  {
    displayName: "Zone",
    key: "zone",
  },
  {
    displayName: "Region",
    key: "region",
  },
  {
    displayName: "Chapter",
    key: "chapter",
  },
  {
    displayName: "District",
    key: "district",
  },
];

const MEMBER_SEARCH_COL = [
  "createdAt",
  "updatedAt",
  "createdBy",
  "updatedBy",
  "memberId",
  "gender",
  "type",
  "fullName",
  "emailId",
  "mobileNumber",
  "addressLine1",
  "addressLine2",
  "city",
  "pincode",
  "state",
  "parentsEmailId",
  "parentsMobileNumber",
  "nationalityId",
  "divisionId",
  "divisionName",
  "subdivisionId",
  "subDivisionName",
  "introducedBy",
  "areaId",
  "areaName",
  "zoneId",
  "zoneName",
  "regionId",
  "regionName",
  "chapterId",
  "chapterName",
  "districtId",
  "districtName",
  "blockId",
  "blockName",
  "introducerName",
  "introducerEmail",
  "introducerMobileNumber",
  "dob",
  "introductionId",
  "profession",
  "present",
];

const SUBSCRIPTION_COL = [
  {
    displayName: "Type",
    key: "type",
  },
  {
    displayName: "Number",
    key: "number",
  },
  {
    displayName: "Expiry Date",
    key: "date",
  },
];

const FAMILY_COL = [
  {
    displayName: "S. No.",
    key: "name",
  },
  {
    displayName: "Name",
    key: "name",
  },
  {
    displayName: "Member Id",
    key: "memberId",
  },
];

const APPOINTMENT_COL = [
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Mainline/Dual Resp.",
    key: "mainline",
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Sub Division",
    key: "subDivision",
  },
  {
    displayName: "Location",
    key: "location",
  },
  {
    displayName: "Appointment Date",
    key: "appointmentDate",
  },
];

const APPOINTMENT_EXPAND_COL = [
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Sub Division",
    key: "subdivision",
  },
  {
    displayName: "Location",
    key: "location",
  },
  {
    displayName: "Appointment Date",
    key: "appointmentDate",
  },
  {
    displayName: "Mainline/Dual Resp.",
    key: "mainline",
  },
];

const PREVIOUS_APPOINTMENT_COL = [
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Mainline/Dual Resp.",
    key: "mainlineDual",
  },
  {
    displayName: "Appointment From Date",
    key: "appointmentFromDate",
  },
  {
    displayName: "Appointment To Date",
    key: "appointmentToDate",
  },
  {
    displayName: "Reason",
    key: "mainline",
  },
];

const PREVIOUS_APPOINTMENT_EXPAND_COL = [
  // {
  //   displayName: "S No",
  //   key: "number",
  // },
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Sub Division",
    key: "subdivision",
  },
  {
    displayName: "Location",
    key: "location",
  },
  {
    displayName: "Appointment From Date",
    key: "appointmentDate",
  },
  {
    displayName: "Appointment To Date",
    key: "appointmentDate",
  },
  {
    displayName: "Mainline/Dual Resp.",
    key: "mainline",
  },
  {
    displayName: "Organization Structure",
    key: "orgnisationStructure",
  },
  {
    displayName: "Reason",
    key: "mainline",
  },
];

const INPROGRESS_APPOINTMENT_COL = [
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Appointment Date",
    key: "appointmentDate",
  },
  {
    displayName: "Mainline/Dual Resp.",
    key: "mainline",
  },
  {
    displayName: "Status",
    key: "status",
  },
];

const ATTENDANCE_COL = [
  {
    displayName: "Month",
    key: "month",
  },
  {
    displayName: "Year",
    key: "year",
  },
];

const UIN_COL = [
  {
    displayName: "S No.",
    key: "sno",
  },
  {
    displayName: "UIN Type",
    key: "uin-type",
  },
  {
    displayName: "UIN No.",
    key: "uin-no",
  },
];

const SPECIAL_GROUP_COL = [
  {
    displayName: "Special Group Name",
    key: "special-group-name",
  },
  {
    displayName: "Induction Date",
    key: "inductionDate",
  },
  {
    displayName: "Graduation Date",
    key: "greduationDate",
  },
];
const EXAMINATION_COL = [
  {
    displayName: "Exam Name",
    key: "exam",
  },
  {
    displayName: "Exam Month",
    key: "examMonth",
  },
  {
    displayName: "Exam Year",
    key: "examYear",
  },
  {
    displayName: "Action",
    key: "action",
  },
];
const AWARDS_COL = [
  {
    displayName: "Award Name",
    key: "awardName",
  },
  {
    displayName: "Award For",
    key: "awardFor",
  },
  {
    displayName: "Month/Year",
    key: "date",
  },
];

const REMARKS_COL = [
  {
    displayName: "Exam",
    key: "exam",
  },
  {
    displayName: "Date",
    key: "date",
  },
];

const GOHONZON_COL = [
  {
    displayName: "Type",
    key: "gohonzonType",
  },
  {
    displayName: "Conferred Date",
    key: "conferralDate",
  },
];

const HDC_COL = [
  {
    displayName: "Organization Structure",
    key: "orgnisationStructure",
  },
  {
    displayName: "Assigned Date",
    key: "assignedAt",
  },
  {
    displayName: "Marked By",
    key: "markedBy",
  },
];

export {
  MEMBER_SEARCH_TABLE_COL,
  MEMBER_SEARCH_COL,
  SUBSCRIPTION_COL,
  FAMILY_COL,
  APPOINTMENT_COL,
  ATTENDANCE_COL,
  UIN_COL,
  SPECIAL_GROUP_COL,
  GOHONZON_COL,
  INPROGRESS_APPOINTMENT_COL,
  PREVIOUS_APPOINTMENT_COL,
  PREVIOUS_APPOINTMENT_EXPAND_COL,
  EXAMINATION_COL,
  AWARDS_COL,
  REMARKS_COL,
  HDC_COL,
  APPOINTMENT_EXPAND_COL,
};
